import React, { useEffect, useState } from "react";
import { getRegions } from "redux/actions/regionActions";
import OnboardingHeader from "./OnboardingHeader";
import PersonalDetails from "./PersonalDetails";
import NextOfKin from "./NextOfKin";
import GuarantorDetails from "./GuarantorDetails";
import FileUploads from "./FileUploads";

const OnBoardingForm = ({ currentStatus }) => {
  const [currentIndex, setCurrentIndex] = useState(currentStatus || 1);
  // const [currentIndex, setCurrentIndex] = useState(4);

  const handleNext = () => setCurrentIndex(currentIndex + 1);
  const handlePrevious = () => setCurrentIndex(currentIndex - 1);

  useEffect(() => {
    getRegions();
  }, []);

  const getCurrentStatusForm = () => {
    switch (currentIndex) {
      case 1:
        return (
          <PersonalDetails
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        );

      case 2:
        return (
          <NextOfKin handleNext={handleNext} handlePrevious={handlePrevious} />
        );

      case 3:
        return (
          <GuarantorDetails
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        );

      case 4:
        return (
          <FileUploads
            handleNext={handleNext}
            handlePrevious={handlePrevious}
          />
        );

      default:
        break;
    }
  };

  return (
    <div>
      <OnboardingHeader currentIndex={currentIndex} />
      <div className="mt-4"></div>
      {getCurrentStatusForm()}
    </div>
  );
};

export default OnBoardingForm;
